@if (user != undefined) {
    <div>
        <!-- Button -->
        <button mat-icon-button [matMenuTriggerFor]="userActions" aria-label="User Actions">
            <span class="relative">
                @if (showAvatar && user?.avatar) {
                    <img class="w-7 h-7 rounded-full" [src]="user.avatar" alt="user avatar">
                }
                @else {
                    <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
                }
            </span>
        </button>
        <mat-menu [xPosition]="'before'" #userActions="matMenu">
            <button mat-menu-item>
                <span class="flex flex-col leading-none">
                    <span>Signed in as</span>
                    <span class="mt-1.5 text-md font-medium">{{user.displayName}}</span>
                </span>
            </button>
            <mat-divider class="my-2"></mat-divider>
            <button mat-menu-item [routerLink]="['/account/profile']">
                <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
                <span>Profile</span>
            </button>
            <!-- <a mat-menu-item [routerLink]="['/account/settings']">
                <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
                <span>Settings</span>
            </a> -->
            <mat-divider class="my-2"></mat-divider>
            <button mat-menu-item (click)="signOut()">
                <mat-icon [svgIcon]="'feather:log-out'"></mat-icon>
                <span>Sign out</span>
            </button>
        </mat-menu>
    </div>
}

@if (user == undefined && guestUser != undefined) {
    <div>
        <!-- Button -->
        <button mat-icon-button [matMenuTriggerFor]="userActions" aria-label="User Actions">
            <span class="relative">
                <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            </span>
        </button>
       <mat-menu [xPosition]="'before'" #userActions="matMenu">
            <button mat-menu-item>
                <span class="flex flex-col leading-none">
                    <span>Signed in as</span>
                    <span class="mt-1.5 text-md font-medium">{{guestUser.displayName}}</span>
                </span>
            </button>
            <mat-divider class="my-2"></mat-divider>
            <button mat-menu-item (click)="signOut()">
                <mat-icon [svgIcon]="'feather:log-out'"></mat-icon>
                <span>Sign out</span>
            </button>
        </mat-menu>
    </div>
}

@if (user == undefined && guestUser == undefined) {
    <button class="flex"
        (click)="signIn()">
        <mat-icon [svgIcon]="'feather:log-in'"></mat-icon>
        <span class="ml-1 my-auto">Sign In</span>
    </button>
}

<!-- <mat-menu class="user-status-menu" #userStatus="matMenu">
    <button mat-menu-item (click)="updateUserStatus('online')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('away')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('busy')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('not-visible')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu> -->
